import $ from 'jquery';
import debounce from './utils/debounce';

require('intersection-observer');

class Footer {
    constructor () {
        this.$document = $(document);
        this.$window = $(window);
        this.$body = $('body');
        this.$page = $('.js-page');
        this.$footer = $('.js-footer');
        this.$footerPlaceholder = $('.js-footer-placeholder');
        this.$fixedFooter = $('.js-fixed-footer');
        this.stickyHeaderHeight = 64;

        this.$window.on('load resize', debounce(() => {
            this.placeholderHeight();
            this.checkFooterHeight();
            this.staticFooter();
        }, 300));

        this.$window.on('scroll', () => {
            this.updateOnScroll();
        });

        this.observeFooter();
    }

    placeholderHeight () {
        let footerHeight = this.$footer.height() + this.stickyHeaderHeight;

        // Adjust if they are logged in
        if (this.$body.hasClass('admin-bar')) {
            footerHeight += 32;
        }

        // Set the height of the placeholder to be the height of the footer
        this.$footerPlaceholder.css('height', `${footerHeight}px`);
    }

    checkFooterHeight () {
        // If the footer is taller than the window, start the footer position from the top
        if (this.$footer.outerHeight(true) > this.$window.innerHeight()) {
            this.$footer.css('bottom', 'unset');
            this.$footer.css('top', this.stickyHeaderHeight);
        } else {
            this.$footer.css('bottom', 0);
            this.$footer.css('top', 'unset');
        }
    }

    updateOnScroll () {
        // Find the position of the placeholder, relative to the window
        let placeholderTop = this.$footerPlaceholder.offset().top - this.$window.scrollTop();

        // Adjust if they are logged in
        if (this.$body.hasClass('admin-bar')) {
            placeholderTop += 32;
        }

        // Set the top position of the footer to be the position of the placeholder (minus the height of the sticky header)
        if (placeholderTop <= 0) {
            placeholderTop += this.stickyHeaderHeight;

            this.$footer.css('top', `${placeholderTop}px`);
        }
    }

    staticFooter () {
        if (this.$page.outerHeight(true) < this.$window.innerHeight()) {
            this.$footer.addClass('is-static');
            this.$footerPlaceholder.hide();
        }
    }

    observeFooter () {
        const footerObserver = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                this.$footer.addClass('is-visible');
            } else {
                this.$footer.removeClass('is-visible');
            }
        });

        footerObserver.observe(this.$footerPlaceholder[0]);
    }
}

export default Footer;
